<app-document-list
  #list
  [filter$]="filter$"
  [hideFields]="['root_id', 'children', 'parent_id']"
  [isSubdocumentDrawerOpen]="true"></app-document-list>
